import { cloneDeep } from 'lodash';
const SET_PROMOS = 'SET_PROMOS';

const initialState = [];

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_PROMOS:
			return action.payload;
		default:
			return state;
	}
}

export function setPromos( promos=[] ){
	return{
		type: SET_PROMOS,
		payload: promos
	}
}



// WEBPACK FOOTER //
// ./src/modules/promos.js